import * as AvailableSpeedActions from './../actions/available-speed.actions';
import {
  AvailableSpeedResource,
  TechnicalError,
} from '@dch/products-business-logic';

export interface AvailableSpeedState {
  availableSpeed: AvailableSpeedResource;
  isPending: boolean;
  error: TechnicalError;
}

export const initialState: AvailableSpeedState = {
  availableSpeed: null,
  isPending: false,
  error: null,
};

export function reducer(
  state: AvailableSpeedState = initialState,
  action: AvailableSpeedActions.Actions,
): AvailableSpeedState {
  switch (action.type) {
    case AvailableSpeedActions.GET_AVAILABLE_SPEED:
      return {
        ...state,
        isPending: true,
        error: null,
      };
    case AvailableSpeedActions.GET_AVAILABLE_SPEED_SUCCESS:
      return {
        ...state,
        availableSpeed: action.payload,
        isPending: false,
        error: null,
      };
    case AvailableSpeedActions.GET_AVAILABLE_SPEED_FAILED:
      return {
        ...state,
        availableSpeed: null,
        error: action.payload,
        isPending: false,
      };
    default:
      return state;
  }
}

export const getAvailableSpeed = (state: AvailableSpeedState) =>
  state.availableSpeed;
export const getTechnicalError = (state: AvailableSpeedState) => state.error;
export const getPending = (state: AvailableSpeedState) => state.isPending;
